<template>
  <div
    class="right-menu-main"
    :style="{
      width: `${widthSize}px`,
      minWidth: !showMe ? '0' : `${widthSize}px`,
      maxWidth: !showMe ? '0' : `${widthSize}px`,
      position: overlay ? 'absolute' : 'relative',
      padding: !showMe ? '0' : '5px',
      paddingLeft: !showMe ? '0' : '10px',
      transition: isTransition ? '0.3s' : '0s',
    }"
  >
    <!-- <div class="slider" @drag="sliderDrag" @dragend="sliderDragEnd"> -->
    <div class="slider" @mousedown="sliderMouseDown"></div>
    <div class="slider-bar"></div>
    <img
      v-if="showCloseButton"
      @click="closeClicked"
      class="close-button"
      src="https://dsmlib.logistics.systems/Icons/Cancel.png"
      style="width: 23px; height: 23px; background-color: white; border-radius: 50%; cursor: pointer; margin:3px;"
      alt=""
    />
    <slot></slot>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      widthSize: 0,
      showMe: true,

      isTransition: true,
    };
  },
  props: {
    overlay: { type: Boolean, default: false },
    maxWidth: { type: Number, default: 500 },
    minWidth: { type: Number, default: 200 },
    defaultWidth: { type: Number, default: 420 },
    showMenu: { type: Boolean, default: true },
    showCloseButton: { type: Boolean, default: true },
    width: { type: Number, default: 0 },
  },
  methods: {
    sliderMouseDown: function (e) {
      this.widthSize = window.innerWidth - (e.clientX - 6);
      this.isTransition = false;
      document.addEventListener('mousemove', this.dragging);
    },
    sliderMouseUp: function (e) {
      document.removeEventListener('mousemove', this.dragging);
      document.removeEventListener('mouseup', this.sliderMouseUp);

      this.isTransition = true;

      let width = window.innerWidth - (e.clientX - 6);
      this.sliderBoundaries(width);
    },
    dragging: function (e) {
      document.addEventListener('mouseup', this.sliderMouseUp);
      let width = window.innerWidth - (e.clientX - 6);
      this.sliderBoundaries(width);
    },
    sliderBoundaries: function (width) {
      if (this.minWidth == -1 || width >= this.minWidth) {
        if (width < 10) {
          this.widthSize = 10;
        } else {
          this.widthSize = width;
        }
      } else {
        this.widthSize = this.minWidth;
        return;
      }

      if (this.maxWidth == -1 || width <= this.maxWidth) {
        if (width > window.innerWidth - 10) {
          this.widthSize = window.innerWidth - 10;
        } else {
          this.widthSize = width;
        }
      } else {
        this.widthSize = this.maxWidth;
        return;
      }
    },

    closeClicked: function () {
      this.showMe = false;
      this.$emit('update:showMenu', this.showMe);
    },
  },
  mounted() {
    this.showMe = this.showMenu;
    this.widthSize = this.defaultWidth;

    if (this.defaultWidth < this.minWidth) {
      this.widthSize = this.minWidth;
    }
    if (this.defaultWidth > this.maxWidth) {
      this.widthSize = this.maxWidth;
    }
  },
  watch: {
    showMenu: function (val) {
      this.showMe = val;
    },
    widthSize: function (val) {
      this.$emit('update:width', val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.right-menu-main {
  width: 420px;
  min-width: 420px;
  max-width: 420px;
  height: 100%;
  top: 0;
  right: 0;
  background-color: white;
  overflow-y: scroll; //before is auto for overflow, changed to this so that it always show the scrollbar
  padding: 5px;
  padding-left: 10px;

  > .slider {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 5px;
    cursor: ew-resize;
    z-index: 5;

    &:active {
      cursor: grabbing;
      width: 100%;
      background-color: transparent;
      position: fixed;
      z-index: 999;
    }
  }

  > .slider-bar {
    position: absolute;
    height: 100%;
    width: 3px;
    left: 3px;
    top: 0;
    background-color: black;
    z-index: 3;
  }

  > .close-button {
    cursor: pointer;
    height: 20px;
    width: 20px;
    top: 5px;
    right: 5px;
    position: absolute;
    z-index: 998;
  }
}
</style>
